export class DeviceUpdateShortInfo {
    constructor() {
        this.DeviceGuid = "";
        this.CurrentVersion = "";
        this.NewVersion = "";
    }
}
/**
 * Object represents the update status of the controller components
 *
 */
export class ControllerUpdatesInfo {
    constructor() {
        /**
         * Array of updates associated with components that coud be update.
         */
        this.UpdatesAvailable = [];
        /**
         * Rest of components that do not require updating or components that retruns some errors while checking of updates.
         */
        this.UpdatesNotAvailable = [];
    }
}
export class UpdateHistory {
    constructor() {
        /**
         * name of update resource to inform user (eq. ExtaLife Radio 868Mhz, Portos Radio 433Mhz, Controller Software etc.)
         *
         * Default key should always exists in English (en-US)
         *
         * As key we have language code as specified in RFC 4646. As value we have description of update in specified language.
         * https://learn.microsoft.com/en-us/aspnet/core/fundamentals/localization?view=aspnetcore-7.0
         * https://www.ietf.org/rfc/rfc4646.txt
         * ex. pl-PL, en-US
         */
        this.UpdatedResourceName = new Map();
        /**
     * Returns the description of the update, if any. As key we have language code as specified in RFC 4646. As value we have description of update in specified language.
     * https://learn.microsoft.com/en-us/aspnet/core/fundamentals/localization?view=aspnetcore-7.0
     * https://www.ietf.org/rfc/rfc4646.txt
     * ex. pl-PL, en-US
     */
        this.UpdateDescription = new Map();
        /**
         * Update creation time, value coud be null if time is not available
         */
        this.UpdateCreationTime = null;
        /**
         * Update version
         */
        this.Version = "";
        /**
         * Update channel
         */
        this.UpdateChannel = "";
    }
}
export class ControllerVersion {
    constructor() {
        this.Resource = "";
        this.Version = "";
        this.Type = null;
    }
}
export var ControllerUpdateType;
(function (ControllerUpdateType) {
    ControllerUpdateType[ControllerUpdateType["RadioUpdate"] = 0] = "RadioUpdate";
    ControllerUpdateType[ControllerUpdateType["SoftwareUpdate"] = 1] = "SoftwareUpdate";
})(ControllerUpdateType || (ControllerUpdateType = {}));
//# sourceMappingURL=IUpdateInfo.js.map